import cn from 'classnames';
import moment from 'moment/moment';
import { useContext } from 'react';
import Skeleton from 'react-loading-skeleton';

import Text from 'components/common/Text';
import { PickYourMealsContext } from 'components/signUpFunnel/Contexts';
import { HOME_CHEF } from 'context/BrandContext';
import { basketCutoffDate, basketCutoffTime } from 'helpers/timeFormat';
import useBrand from 'hooks/useBrand';
import { BRAINTREE } from 'lib/constants';
export const PaymentCallOut = ({ editingCutoff, vendor = '', box, firstDeliveryDays }) => {
  const isHomeChef = useBrand(HOME_CHEF);
  const { isPickYourMeals } = useContext(PickYourMealsContext);

  const isTempoChargeDay = !isHomeChef && new Date().getDay() === 3;
  const isHomeChefChargeDay = isHomeChef && new Date().getDay() === 5;

  const isFirstDeliveryDateOnCurrentMenu = (deliveryDate, firstDeliveryDays) => {
    if (!deliveryDate || !firstDeliveryDays?.length) return false;
    return firstDeliveryDays.some(day => day.value === deliveryDate);
  };

  const displayPayZeroTodayMessage =
    !isPickYourMeals && !box?.sellThroughEnabled && !isTempoChargeDay && !isHomeChefChargeDay;

  const ChargeDateMessage = () => {
    if (displayPayZeroTodayMessage) {
      return (
        <>
          <Text brandStylesOverrides="h6 text-primary-dark" className="mb-2">
            $0 Today - Billed{' '}
            {isFirstDeliveryDateOnCurrentMenu(box?.deliveryDate, firstDeliveryDays)
              ? `${isHomeChef ? 'Friday' : 'Wednesday'}`
              : `on ${moment(box?.editingCutoff).format('MMMM D')}`}
          </Text>
          <Text brandStylesOverrides="textSm text-primary-dark">
            You'll get to make your meal selections before we charge your{' '}
            {vendor === BRAINTREE ? 'PayPal account' : 'card'} on{' '}
            {`${basketCutoffDate(editingCutoff)} at ${basketCutoffTime(editingCutoff)}.`}
          </Text>
        </>
      );
    } else {
      return (
        <>
          <Text brandStylesOverrides="textMd text-primary-dark" className="mb-2">
            Your {vendor === BRAINTREE ? 'PayPal account' : 'card'} will not be charged until{' '}
            {`${basketCutoffDate(editingCutoff)} at ${basketCutoffTime(editingCutoff)}`}. For future
            deliveries, you'll be charged weekly on {moment(editingCutoff).format('dddd')}.
          </Text>
        </>
      );
    }
  };

  return (
    <div
      className={cn('mb-2 rounded border border-solid p-2', {
        'border-green-100 bg-green-50 ': isHomeChef,
        'border-charcoal-60 bg-charcoal-50 ': !isHomeChef,
      })}
    >
      {editingCutoff ? <ChargeDateMessage /> : <Skeleton className="w-full" />}
    </div>
  );
};

PaymentCallOut.propTypes = {
  editingCutoff: PropTypes.string.isRequired,
  vendor: PropTypes.string,
  box: PropTypes.object,
  firstDeliveryDays: PropTypes.array,
};
